export default __webpack_public_path__ + "static/media/AvatarKids-17.901d4110.png";